import { PreScreeningQuestion } from "../../types/landingPage";
import { mapQuestionnaireToAttributes as mapQuestionnaireToAttributesNew } from "./orchestrator";
import { AttributeValueInput, QuestionnaireAnswers } from "./types";

/**
 * Main entry point for attribute mapping.
 *
 * This function maps questionnaire answers to attribute values using the
 * configuration-driven attribute mapping system.
 *
 * @param questionnaireAnswers The user's answers.
 * @param screenerConfig The configuration for the screener, including mappings.
 * @param screenerId The unique ID of the screener.
 * @param countryCode The user's country code.
 * @returns An array of attribute value inputs.
 */
export function mapQuestionnaireToAttributes(
  questionnaireAnswers: QuestionnaireAnswers,
  screenerConfig: PreScreeningQuestion[],
  _screenerId: string,
  countryCode: string
): AttributeValueInput[] {
  return mapQuestionnaireToAttributesNew(
    questionnaireAnswers,
    screenerConfig,
    countryCode
  );
} 